module.exports = __webpack_public_path__ + "images/shuffle@2x.png?9d68ff71";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shuffle@2x.png
// module id = 702
// module chunks = 7